import { ChangeEvent, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "Store/DashboardStore";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * 半角数字を全角数字に変換するカスタムフック
 * @returns 入力値と変換後の値、およびハンドラー関数
 */
const useHalfWidthToFullWidth = () => {
  const [inputValue, setInputValue] = useState<string>('');
  const [convertedValue, setConvertedValue] = useState<string>('');

  const convertHalfWidthToFullWidthDigits = (str: string): string => {
    return str.replace(/[0-9]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0xFEE0));
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const halfWidthStr = e.target.value;
    const fullWidthStr = convertHalfWidthToFullWidthDigits(halfWidthStr);
    setInputValue(halfWidthStr);
    setConvertedValue(fullWidthStr);
  };

  return { inputValue, convertedValue, handleChange };
};

export default useHalfWidthToFullWidth;